import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, Row, Col, Table,Popover,ConfigProvider,theme } from 'antd';
import help from '../../config/help.json';
import { QuestionCircleOutlined,DownloadOutlined } from '@ant-design/icons';
import { CSVLink } from 'react-csv';



import './analytics.css';


var cc_data;

class DeviceCoverageCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
		 }
	}

	async componentDidUpdate(prevProps) {
	}


	render() {
		const { defaultAlgorithm, darkAlgorithm } = theme;
		const {  userTheme,opensearchDeviceCoverageList } = this.props;

		cc_data = opensearchDeviceCoverageList || [];
		let dataset = [];
		cc_data.forEach(d =>{
			if(d.appversion && d.appversion.buckets ){
				d.appversion.buckets.forEach(c => {
					if(c.platform && c.platform.buckets){
						c.platform.buckets.forEach(f => {
							dataset.push({platform:f.key, appName: d.key ,appVersion: c.key, count: f.devicesno.value, key:c.key});
						})
					}
					
				})
			}
		})
		// takes an array of objects and the name of a property of these objects
		function getGroupByKeys(array, index){
			let temparr = [];
			array.forEach(d => {
				if(d && d[index]){
					if(!temparr.some(f => f.text === d[index])){
						temparr.push({text:d[index], value:d[index]})
					}
				}
			})
			return temparr;
		}
		const columns = [
			{
			  title: 'Platform',
			  dataIndex: 'platform',
			  filters: getGroupByKeys(dataset, "platform"),
			  onFilter: (value, record) => record.platform.indexOf(value) === 0,
			  sorter: (a, b) => a.platform.localeCompare(b.platform),
			  
			},
			{
			  title: 'App Name',
			  dataIndex: 'appName',
			  filters: getGroupByKeys(dataset, "appName"),
			  onFilter: (value, record) => record.appName.indexOf(value) === 0,
			  sorter: (a, b) => a.appName.localeCompare(b.appName),
			  
			},
			{
				title: 'App Version',
				dataIndex: 'appVersion',
				filters: getGroupByKeys(dataset, "appVersion"),
			  onFilter: (value, record) => record.appVersion.indexOf(value) === 0,
			  sorter: (a, b) => a.appVersion.localeCompare(b.appVersion),
			  },
			{
				title: 'Count',
				dataIndex: 'count',
				sorter: (a, b) => a.count - b.count,
				defaultSortOrder: 'descend',
			  }
		  ];

		return (
			<ConfigProvider theme={{
				algorithm: userTheme === 'dark' ?darkAlgorithm : defaultAlgorithm,
			  }}>
      <Card className="analyticCard analyticActiveUsersCard">
				<h3 className="title">{`Device Coverage  `}
				<Popover placement="topLeft"
						overlayStyle={{width:'300px'}}
						content= {help.find(d=> d.name ==='DeviceCoverageCard').en}
						trigger="click"><QuestionCircleOutlined />
					</Popover>
					<CSVLink data={dataset} target="_blank" filename={"Device Coverage.csv"}>
						<DownloadOutlined />
					</CSVLink>
				</h3>
				<Row>
				 <Col span={24}>
				 	<Table style={{ height: 400, width: '100%' }} theme={userTheme} dataSource={dataset} columns={columns} pagination={{pageSize:5}} />
					{/* <ReactECharts style={{ height: 320, width: '100%' }} theme={userTheme} option={option} notMerge={true} showLoading={loading} loadingOption={{color:"#74add1"}} /> */}
				</Col>
 				</Row>
     </Card>
	 </ConfigProvider>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userTheme: state.user.userTheme,
	selectedOrganization: state.user.selectedOrganization,
	opensearchDeviceCoverageList: state.analytics.opensearchDeviceCoverageList
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DeviceCoverageCard));
